"use client";
import React from "react";
import styled from "styled-components";
import Link from "next/link";
import {Black, hover, text, Transition, white} from "@/styles/globalStyleVars";
import arrow from "@/public/images/static/arrow-right.svg";
import Image from "next/image";

const Button = ({
  onSubmit,
  text,
  src,
  img,
  hoverImg,
  fontSize,
  fontWeight,
  color,
  letterSpacing,
  lineHeight,
  margin,
  background,
  borderRadius,
  border,
  width,
  height,
  hoverBackground,
  target,
  borderColor,
  hoverColor,
  icon,
  marginSm,
  onClick,
  className,
}) => {
  return (
    <StyledBtn
      onClick={onClick}
      className={`${className ? className : null} dc-btn`}
      fontSize={fontSize}
      fontWeight={fontWeight}
      color={color}
      background={background}
      lineHeight={lineHeight}
      letterSpacing={letterSpacing}
      margin={margin}
      border={border}
      img={img}
      borderRadius={borderRadius}
      width={width}
      hoverImg={hoverImg}
      hoverBackground={hoverBackground}
      height={height}
      borderColor={borderColor}
      target={target}
      hoverColor={hoverColor}
      onSubmit={onSubmit}
      icon={icon}
      marginSm={marginSm}
    >
      {src && typeof src === "string" ? (
        src?.startsWith("http") || src?.startsWith("www") ? (
          <a href={src} target="_blank" rel="noopener noreferrer">
            {
              icon ?
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
  <g id="Icon" transform="translate(-2 -2)">
    <path id="Path_9478" data-name="Path 9478" d="M10,2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Zm0,14.857c-.714,0-1.646-1.469-2.063-4h4.126C11.646,15.389,10.714,16.857,10,16.857ZM7.794,11.714c-.051-.537-.08-1.109-.08-1.714s.029-1.177.08-1.714h4.411c.051.537.08,1.109.08,1.714s-.029,1.177-.08,1.714ZM3.143,10a7.046,7.046,0,0,1,.223-1.714H6.651c-.051.571-.08,1.143-.08,1.714s.029,1.143.08,1.714H3.366A7.046,7.046,0,0,1,3.143,10ZM10,3.143c.714,0,1.646,1.469,2.063,4H7.937c.417-2.531,1.349-4,2.063-4Zm3.349,5.143h3.286a6.7,6.7,0,0,1,0,3.429H13.349A12.3,12.3,0,0,0,13.429,10,12.3,12.3,0,0,0,13.349,8.286Zm2.857-1.143H13.211a10.783,10.783,0,0,0-1.189-3.7,6.9,6.9,0,0,1,4.2,3.7Zm-8.229-3.7a10.783,10.783,0,0,0-1.189,3.7H3.777a6.9,6.9,0,0,1,4.2-3.7Zm-4.2,9.411H6.789a10.783,10.783,0,0,0,1.189,3.7,6.9,6.9,0,0,1-4.2-3.7Zm8.246,3.7a10.783,10.783,0,0,0,1.189-3.7h3.011A6.9,6.9,0,0,1,12.023,16.554Z" fill="#fff"/>
  </g>
</svg>

                    {text}</span>

                  :
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
  <g id="Icon" transform="translate(-2 -2)">
    <path id="Path_9478" data-name="Path 9478" d="M10,2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Zm0,14.857c-.714,0-1.646-1.469-2.063-4h4.126C11.646,15.389,10.714,16.857,10,16.857ZM7.794,11.714c-.051-.537-.08-1.109-.08-1.714s.029-1.177.08-1.714h4.411c.051.537.08,1.109.08,1.714s-.029,1.177-.08,1.714ZM3.143,10a7.046,7.046,0,0,1,.223-1.714H6.651c-.051.571-.08,1.143-.08,1.714s.029,1.143.08,1.714H3.366A7.046,7.046,0,0,1,3.143,10ZM10,3.143c.714,0,1.646,1.469,2.063,4H7.937c.417-2.531,1.349-4,2.063-4Zm3.349,5.143h3.286a6.7,6.7,0,0,1,0,3.429H13.349A12.3,12.3,0,0,0,13.429,10,12.3,12.3,0,0,0,13.349,8.286Zm2.857-1.143H13.211a10.783,10.783,0,0,0-1.189-3.7,6.9,6.9,0,0,1,4.2,3.7Zm-8.229-3.7a10.783,10.783,0,0,0-1.189,3.7H3.777a6.9,6.9,0,0,1,4.2-3.7Zm-4.2,9.411H6.789a10.783,10.783,0,0,0,1.189,3.7,6.9,6.9,0,0,1-4.2-3.7Zm8.246,3.7a10.783,10.783,0,0,0,1.189-3.7h3.011A6.9,6.9,0,0,1,12.023,16.554Z" fill="#fff"/>
  </g>
</svg>

                    {text}</span>


            }
          </a>
        ) : (
            <Link prefetch={true}  href={src || "/"}>
              {
                icon ?
                    <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
  <g id="Icon" transform="translate(-2 -2)">
    <path id="Path_9478" data-name="Path 9478" d="M10,2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Zm0,14.857c-.714,0-1.646-1.469-2.063-4h4.126C11.646,15.389,10.714,16.857,10,16.857ZM7.794,11.714c-.051-.537-.08-1.109-.08-1.714s.029-1.177.08-1.714h4.411c.051.537.08,1.109.08,1.714s-.029,1.177-.08,1.714ZM3.143,10a7.046,7.046,0,0,1,.223-1.714H6.651c-.051.571-.08,1.143-.08,1.714s.029,1.143.08,1.714H3.366A7.046,7.046,0,0,1,3.143,10ZM10,3.143c.714,0,1.646,1.469,2.063,4H7.937c.417-2.531,1.349-4,2.063-4Zm3.349,5.143h3.286a6.7,6.7,0,0,1,0,3.429H13.349A12.3,12.3,0,0,0,13.429,10,12.3,12.3,0,0,0,13.349,8.286Zm2.857-1.143H13.211a10.783,10.783,0,0,0-1.189-3.7,6.9,6.9,0,0,1,4.2,3.7Zm-8.229-3.7a10.783,10.783,0,0,0-1.189,3.7H3.777a6.9,6.9,0,0,1,4.2-3.7Zm-4.2,9.411H6.789a10.783,10.783,0,0,0,1.189,3.7,6.9,6.9,0,0,1-4.2-3.7Zm8.246,3.7a10.783,10.783,0,0,0,1.189-3.7h3.011A6.9,6.9,0,0,1,12.023,16.554Z" fill="#fff"/>
  </g>
</svg>

                      {text}</span>

                    :
                    <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
  <g id="Icon" transform="translate(-2 -2)">
    <path id="Path_9478" data-name="Path 9478" d="M10,2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Zm0,14.857c-.714,0-1.646-1.469-2.063-4h4.126C11.646,15.389,10.714,16.857,10,16.857ZM7.794,11.714c-.051-.537-.08-1.109-.08-1.714s.029-1.177.08-1.714h4.411c.051.537.08,1.109.08,1.714s-.029,1.177-.08,1.714ZM3.143,10a7.046,7.046,0,0,1,.223-1.714H6.651c-.051.571-.08,1.143-.08,1.714s.029,1.143.08,1.714H3.366A7.046,7.046,0,0,1,3.143,10ZM10,3.143c.714,0,1.646,1.469,2.063,4H7.937c.417-2.531,1.349-4,2.063-4Zm3.349,5.143h3.286a6.7,6.7,0,0,1,0,3.429H13.349A12.3,12.3,0,0,0,13.429,10,12.3,12.3,0,0,0,13.349,8.286Zm2.857-1.143H13.211a10.783,10.783,0,0,0-1.189-3.7,6.9,6.9,0,0,1,4.2,3.7Zm-8.229-3.7a10.783,10.783,0,0,0-1.189,3.7H3.777a6.9,6.9,0,0,1,4.2-3.7Zm-4.2,9.411H6.789a10.783,10.783,0,0,0,1.189,3.7,6.9,6.9,0,0,1-4.2-3.7Zm8.246,3.7a10.783,10.783,0,0,0,1.189-3.7h3.011A6.9,6.9,0,0,1,12.023,16.554Z" fill="#fff"/>
  </g>
</svg>

                      {text}</span>


              }
            </Link>
        )
      ) : (
          <a target={target || "_self"}>
            {
              icon ?
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
  <g id="Icon" transform="translate(-2 -2)">
    <path id="Path_9478" data-name="Path 9478" d="M10,2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Zm0,14.857c-.714,0-1.646-1.469-2.063-4h4.126C11.646,15.389,10.714,16.857,10,16.857ZM7.794,11.714c-.051-.537-.08-1.109-.08-1.714s.029-1.177.08-1.714h4.411c.051.537.08,1.109.08,1.714s-.029,1.177-.08,1.714ZM3.143,10a7.046,7.046,0,0,1,.223-1.714H6.651c-.051.571-.08,1.143-.08,1.714s.029,1.143.08,1.714H3.366A7.046,7.046,0,0,1,3.143,10ZM10,3.143c.714,0,1.646,1.469,2.063,4H7.937c.417-2.531,1.349-4,2.063-4Zm3.349,5.143h3.286a6.7,6.7,0,0,1,0,3.429H13.349A12.3,12.3,0,0,0,13.429,10,12.3,12.3,0,0,0,13.349,8.286Zm2.857-1.143H13.211a10.783,10.783,0,0,0-1.189-3.7,6.9,6.9,0,0,1,4.2,3.7Zm-8.229-3.7a10.783,10.783,0,0,0-1.189,3.7H3.777a6.9,6.9,0,0,1,4.2-3.7Zm-4.2,9.411H6.789a10.783,10.783,0,0,0,1.189,3.7,6.9,6.9,0,0,1-4.2-3.7Zm8.246,3.7a10.783,10.783,0,0,0,1.189-3.7h3.011A6.9,6.9,0,0,1,12.023,16.554Z" fill="#fff"/>
  </g>
</svg>

                    {text}</span>

                  :
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
  <g id="Icon" transform="translate(-2 -2)">
    <path id="Path_9478" data-name="Path 9478" d="M10,2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Zm0,14.857c-.714,0-1.646-1.469-2.063-4h4.126C11.646,15.389,10.714,16.857,10,16.857ZM7.794,11.714c-.051-.537-.08-1.109-.08-1.714s.029-1.177.08-1.714h4.411c.051.537.08,1.109.08,1.714s-.029,1.177-.08,1.714ZM3.143,10a7.046,7.046,0,0,1,.223-1.714H6.651c-.051.571-.08,1.143-.08,1.714s.029,1.143.08,1.714H3.366A7.046,7.046,0,0,1,3.143,10ZM10,3.143c.714,0,1.646,1.469,2.063,4H7.937c.417-2.531,1.349-4,2.063-4Zm3.349,5.143h3.286a6.7,6.7,0,0,1,0,3.429H13.349A12.3,12.3,0,0,0,13.429,10,12.3,12.3,0,0,0,13.349,8.286Zm2.857-1.143H13.211a10.783,10.783,0,0,0-1.189-3.7,6.9,6.9,0,0,1,4.2,3.7Zm-8.229-3.7a10.783,10.783,0,0,0-1.189,3.7H3.777a6.9,6.9,0,0,1,4.2-3.7Zm-4.2,9.411H6.789a10.783,10.783,0,0,0,1.189,3.7,6.9,6.9,0,0,1-4.2-3.7Zm8.246,3.7a10.783,10.783,0,0,0,1.189-3.7h3.011A6.9,6.9,0,0,1,12.023,16.554Z" fill="#fff"/>
  </g>
</svg>

                    {text}</span>


            }
          </a>
      )}
    </StyledBtn>
  );
};

const StyledBtn = styled.div`
  &.dc-btn {
    margin: ${(props) => props.margin || "0"};
    width: ${(props) => props.width || "fit-content"};
    height: ${(props) => props.height || "40"}px;
    cursor: pointer;

    a {
      display: flex;
      width: ${(props) => props.width || "fit-content"};
      height: 100%;
      align-items: center;
      justify-content: center;
      font-size: ${(props) => props.fontSize || "16"}px;
      font-weight: ${(props) => props.fontWeight || 500};
      letter-spacing: ${(props) => props.letterSpacing || '-0.16'}px;
      margin: 0;
      line-height: ${(props) => props.lineHeight || "20"}px;
      background-color: ${(props) => props.background || hover};
      position: relative;
      border-radius: ${(props) => props.borderRadius || "20"}px;
      overflow: hidden;
      z-index: 0;
      transition: border 0.3s ease;
      padding: 12px 36px;
      box-sizing: border-box;
      border: ${(p) => p.border || "0"};
      color: ${(props) => props.color || white};

      span {
        transition: color 0.3s ease;
        color: ${(props) => props.color || white};
        position: relative;
        z-index: 2;
        display: inline-flex;
        align-items: center;
        svg {
          margin-right: 8px;
          transition: 0.6s ${Transition};
        }
      }

      &:before {
        //bottom: 0;
        content: "";
        display: block;
        position: absolute;
        right: 0;
        top: 100%;
        left: 0;
        background-color: ${(p) => p.hoverBackground || text};
        height: 100%;
        width: 100%;
        margin: auto;
        transition: all 0.5s ${Transition};
        border-radius: 22px;
      }

      &:hover {
        span {
          color: ${(props) => props.hoverColor || `#FFF`};
        }

        img {
          filter: invert(92%) sepia(99%) saturate(1%) hue-rotate(235deg)
            brightness(105%) contrast(100%);
        }

        &:before {
          top: 0;
        }
      }

      &:focus {
        color: #222222;
      }
    }

    @media (max-width: 600px) {
      ${(p) => (p.marginSm ? `margin:${p.marginSm}` : "")}
    }
  }
`;

export default React.memo(Button);
